// extracted by mini-css-extract-plugin
module.exports = {"legend-icon-available":"styles-module__legend-icon-available___2SpnD","timezone-select":"styles-module__timezone-select___mQFl5"};